import { render, staticRenderFns } from "./Privpol.vue?vue&type=template&id=70f1ea82&"
import script from "./Privpol.vue?vue&type=script&lang=js&"
export * from "./Privpol.vue?vue&type=script&lang=js&"
import style0 from "./Privpol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports